import axios from 'axios';

const api = axios.create({
  baseURL: 'https://api.meamo.com.br',
});
export default api;
